import React from "react";
import { Stack, TextField, MenuItem, Box } from "@mui/material";
import AllTransactionsSearch from "./AllTransactionsSearch";

const AllTransactionsFilters = ({
  searchText,
  onSearchChange,
  searchFilter,
  onSearchFilterChange,
  statusFilter,
  onStatusChange,
  isMobile,
}) => {
  return (
    <Stack
      direction={isMobile ? "column" : "row"}
      spacing={2}
      alignItems={isMobile ? "stretch" : "center"}
    >
      {/* Full Width Search */}
      <Box sx={{ flex: 1 }}>
        <AllTransactionsSearch
          searchText={searchText}
          onSearchChange={onSearchChange}
          searchFilter={searchFilter}
          onFilterChange={onSearchFilterChange}
        />
      </Box>

      {/* Status Filter */}
      <TextField
        select
        label="Status"
        value={statusFilter}
        onChange={(e) => onStatusChange(e.target.value)}
        size="small"
        sx={{ minWidth: isMobile ? "100%" : "180px" }}
      >
        <MenuItem value="">All</MenuItem>
        <MenuItem value="COMPLETED">Completed</MenuItem>
        <MenuItem value="FAILED">Failed</MenuItem>
      </TextField>
    </Stack>
  );
};

export default AllTransactionsFilters;
